export function formatIban(iban: string): string {
    return iban.replace(/\s/g, '').toUpperCase().replace(/(.{4})(?=.)/g, '$1 ');
}
